import Teams from "./Teams";

export default Teams;
